// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-ac923e20]{display:flex;align-items:center;justify-content:center}.content .password-box[data-v-ac923e20]{text-align:center;position:relative}.content .forget-pw[data-v-ac923e20]{position:absolute;top:3.125rem;right:4.479167rem}.content .el-button[data-v-ac923e20]{margin-top:1.041667rem}", ""]);
// Exports
module.exports = exports;
